import { useState } from 'react';
import { Flex, Box, Icon } from '@vibe/core';
import { DropdownChevronDown, DropdownChevronRight } from '@vibe/icons';

type SidebarWidgetProps = {
  title: string;
  description: string;
  children: React.ReactNode;
  wrapChildren?: boolean;
  collapsed?: boolean;
  icon: any;
};

export function SidebarWidget({ title, description, children, wrapChildren = true, collapsed = false, icon }: SidebarWidgetProps) {
  const [collapseWidget, setCollapseWidget] = useState<boolean | false>(collapsed);

  return (
    <div className={!collapseWidget ? 'SidebarWidget' : 'SidebarWidget SidebarWidget--Collapsed'}>
      <Box marginBottom={!collapseWidget ? 'medium' : undefined} className="SidebarWidget--Header">
        <Flex gap={8} direction="column" align="start">
          <Flex
            gap={8}
            style={{ width: '100%' }}
            onClick={() => {
              {
                collapseWidget ? setCollapseWidget(false) : setCollapseWidget(true);
              }
            }}
          >
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                color: '#323338',
              }}
              className="DropdownIcon"
            >
              <Icon icon={icon} size={20} />
            </div>
            <h5 style={{ flex: 1 }}>{title}</h5>
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                color: '#323338',
              }}
              className="DropdownIcon"
            >
              <Icon icon={!collapseWidget ? DropdownChevronDown : DropdownChevronRight} size={28} />
            </div>
          </Flex>
          {!collapseWidget ? <span className="SidebarWidget__Description">{description}</span> : null}
        </Flex>
      </Box>
      {!collapseWidget ? (
        <>
          {wrapChildren ? (
            <div>
              <Flex gap={10} direction="column" align="start" style={{ width: '100%' }}>
                <>{children}</>
              </Flex>
            </div>
          ) : (
            children
          )}
        </>
      ) : null}
    </div>
  );
}
